/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-inner-declarations */
(function ($) {
  window.DGS.OnLoad.getInstance().register(function () {
    if ($('#wrapper .sales-rep-contact').length) {
      var radioButtonLabelHandler = function radioButtonLabelHandler() {
        $radioButtonInputLabel.on('click', function () {
          $radioButtonInputLabel.removeClass('checked');
          $radioButtonInputLabel.each(function () {
            $(this).parent()[0].children[0].removeAttribute('checked', 'checked');
          });
        });
        $radioButtonInputLabel.each(function () {
          $(this).on('click', function () {
            $(this).addClass('checked');
            $radioButtonInputLabel.removeClass('unchecked');
            $(this).parent()[0].children[0].setAttribute('checked', 'checked');
          });
        });
      };
      var focusHandler = function focusHandler() {
        $inputs.focusin(function () {
          $("#".concat($(this).attr('id'), "_scope label")).addClass('isFocus');
        });
        $inputs.focusout(function () {
          if (!$("#".concat($(this).attr('id'), "_scope input")).val()) {
            $("#".concat($(this).attr('id'), "_scope label")).removeClass('isFocus');
          }
          submitFormFunction.preValidation(this);
        });
      };
      var checkInputFieldValidation = function checkInputFieldValidation() {
        for (var i = 0; i < $inputFields.length; i++) {
          if ($('.scfValidatorRequired').length > 0 && $inputFields[i].value === '') {
            $inputFields[i].classList.add('inputError');
            $inputFields[i].blur();
          }
          for (var j = 0; j < $labels.length; j++) {
            if ($labels[j].getAttribute('for') === $inputFields[i].getAttribute('id') && $inputFields[i].value !== '') {
              $labels[j].classList.add('isFocus');
            }
          }
        }
      };
      var validateRadioButton = function validateRadioButton() {
        var $scfRadioButtonList = document.querySelectorAll('.scfRadioButtonList');
        $scfRadioButtonList.forEach(function (list) {
          var radio = list.querySelectorAll('.radioButton');
          var listIsChecked = checkParentRadioList(list);
          for (var i = 0; i < radio.length; i++) {
            if ($('.scfValidatorRequired').length > 0 && !listIsChecked) {
              radio[i].classList.add('unchecked');
            } else {
              if (radio[i].parentNode.children[0].checked) {
                radio[i].classList.add('checked');
              }
              radio[i].classList.remove('unchecked');
            }
          }
        });
      };
      // There are no sitecore sales rep contact form components on page. Break out
      $("<label class='radioButton'/>").insertAfter('.scfRadioButtonList tr td label');
      $('.scfCheckbox input').addClass('checkBox');
      var $radioButtonInput = $('.scfRadioButtonList tr td input');
      $radioButtonInput.addClass('radio');
      var $radioButtonInputLabel = $('.scfRadioButtonList tr td .radioButton');
      radioButtonLabelHandler();
      if ($('.name\\.State').length) {
        $('.scfSingleLineTextBorder:nth-child(-n+3)').addClass('stateVisible');
      }
      var $labels = $('.form.sales-rep-contact .scfSingleLineTextBorder label, .form.sales-rep-contact .scfEmailBorder label, .form.sales-rep-contact .scfTelephoneBorder label');
      var $inputs = $('.form.sales-rep-contact .scfSingleLineTextBorder .scfSingleLineGeneralPanel input, .form.sales-rep-contact .scfEmailBorder .scfEmailGeneralPanel input, .form.sales-rep-contact .scfTelephoneBorder .scfTelephoneGeneralPanel input');
      focusHandler();
      var $inputFields = $('.scfSectionContent .scfSingleLineGeneralPanel input');
      $inputFields.push(document.querySelector('.scfTelephoneTextBox'), document.querySelector('.scfEmailTextBox'));
      checkInputFieldValidation();
      var checkParentRadioList = function checkParentRadioList(list) {
        var $element = list.querySelectorAll('input[type="radio"]');
        var isChecked = false;
        $element.forEach(function (element) {
          if (element.checked) {
            isChecked = element.checked;
          }
        });
        return isChecked;
      };
      validateRadioButton();
      var checkBox = document.querySelector('.checkBox');
      if ($('.scfValidatorRequired').length > 0 && !checkBox.checked) {
        checkBox.classList.add('unchecked');
      }
      var submitFormFunction = {
        isValid: false,
        validationDataName: 'data-val-validationexpression',
        init: function init() {
          var _this = this;
          submitFormFunction.fakeInputs();
          document.querySelectorAll('.scfForm input[type="submit"].fake-button').forEach(function (element) {
            element.addEventListener('click', _this.clickHandler, false);
          });
          document.querySelectorAll('.scfForm input[type="text"]').forEach(function (element) {
            element.addEventListener('keyup', _this.pressHandler, false);
          });
        },
        pressHandler: function pressHandler(event) {
          submitFormFunction.preValidation(event.target);
        },
        regexpValidation: function regexpValidation($input, elements, inputValue) {
          var regExp, regExp2, currentIndex;
          if (elements[0]) {
            regExp = new RegExp(String(elements[0].getAttribute(this.validationDataName)));
            regExp = regExp.test(inputValue);
            currentIndex = 0;
          }
          if (elements[1]) {
            regExp2 = new RegExp(String(elements[1].getAttribute(this.validationDataName)));
            regExp2 = regExp2.test(inputValue);
            currentIndex = regExp && !regExp2 ? 1 : 0;
          }
          var regExpValid = (regExp || regExp2) && inputValue.length > 0;
          if (regExpValid) {
            elements.each(function (index, element) {
              return element && element.style ? element.style.display = 'none' : null;
            });
            $input.classList.remove('inputError');
          } else {
            elements[currentIndex].style.display = 'block';
            $input.classList.add('inputError');
          }
          return !regExpValid;
        },
        preValidation: function preValidation($input) {
          var singleLineField = $($input).parent('.scfSingleLineGeneralPanel');
          if (singleLineField.length && !singleLineField.siblings('.scfRequired').length) {
            return;
          }
          var inputValue = $input.value;
          var validationData = $($input).parent().find("[".concat(this.validationDataName, "]"));
          return this.regexpValidation($input, validationData, inputValue);
        },
        checkIsRequired: function checkIsRequired(element) {
          return element.contains(element.querySelector('.scfRequired')) || element.contains(element.querySelector('.scfValidatorRequired'));
        },
        validate: function validate(event) {
          var _this2 = this;
          var validated;
          this.isValid = false;
          $(event.target).closest('.scfForm').find('.scfSectionContent > div').each(function (index, element) {
            var $input = element.querySelector('input[type="text"]');
            var $radio = element.querySelectorAll('input[type="radio"]');
            var $checkbox = element.querySelector('input[type="checkbox"]');
            if ($input) {
              var isRequired = _this2.checkIsRequired(element);
              if (isRequired) {
                validated = _this2.preValidation($input);
                _this2.isValid = _this2.isValid ? true : validated;
              }
            }
            if ($radio.length) {
              var _isRequired = _this2.checkIsRequired(element);
              if (_isRequired) {
                var isChecked;
                $radio.forEach(function (el, i) {
                  return isChecked = isChecked ? true : el.checked;
                });
                _this2.isValid = _this2.isValid ? true : !isChecked;
                element.querySelectorAll('label.radioButton').forEach(function (el, i) {
                  return isChecked ? el.classList.remove('unchecked') : el.classList.add('unchecked');
                });
              }
            }
            if ($checkbox) {
              var _isRequired2 = _this2.checkIsRequired(element);
              if (_isRequired2) {
                $checkbox.checked ? $checkbox.classList.remove('unchecked') : $checkbox.classList.add('unchecked');
                _this2.isValid = _this2.isValid ? true : !$checkbox.checked;
              }
            }
          });
        },
        fakeInputs: function fakeInputs() {
          document.querySelectorAll('.scfForm input[type="submit"]').forEach(function (element) {
            var newElement = element.cloneNode(true);
            newElement.setAttribute('onclick', null);
            newElement.classList.add('fake-button');
            element.parentElement.appendChild(newElement);
            element.style.display = 'none';
          });
        },
        clickHandler: function clickHandler(e) {
          e.preventDefault();
          submitFormFunction.validate(e);
          if (!submitFormFunction.isValid) {
            var parent = e.target.parentNode;
            parent.querySelector('.scfForm input[type="submit"]:not(.fake-button)').click();
          } else {
            document.querySelector('.inputError, .unchecked').scrollIntoView();
          }
        }
      };
      submitFormFunction.init();
    }
  });
})(jQuery);